import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px;
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
`;

const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 24px;
`;

const ErrorTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 16px;
`;

const ErrorMessage = styled.p`
  font-size: 1.125rem;
  margin-bottom: 32px;
  opacity: 0.9;
  max-width: 500px;
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
  }
`;

/**
 * Componente de proteção específico para funcionalidades exclusivas dos Beatt Admins
 * Impede o acesso de usuários que não possuem role BEATT_ADMIN
 */
const BeattAdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  // Se não estiver autenticado, redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se não for BEATT_ADMIN, mostra página de erro personalizada
  if (user?.role !== 'BEATT_ADMIN') {
    return (
      <ErrorContainer>
        <ErrorIcon>🚫</ErrorIcon>
        <ErrorTitle>Acesso Restrito</ErrorTitle>
        <ErrorMessage>
          Esta funcionalidade é exclusiva para Beatt Admins. 
          Apenas usuários com permissões especiais podem acessar 
          a gestão de Quick Checks.
        </ErrorMessage>
        <BackButton onClick={() => window.history.back()}>
          ← Voltar
        </BackButton>
      </ErrorContainer>
    );
  }

  // Se for BEATT_ADMIN, permite acesso
  return children;
};

export default BeattAdminRoute;